import React from 'react';

/**
 * THE warning-triangle glyph. One path, every surface.
 *
 * 🔀 Extracted 2026-09-30 from two verbatim copies — `components/UserAutocomplete.js`
 * (the placeholder-user marker) and `components/budget/CrewDayGrid.js` (the
 * unpriced-premium marker) — when the gag panel's "Pending budget review"
 * marker would have been a THIRD. Both call sites were migrated in the same
 * commit (Code Unification Principle).
 *
 * Decorative: `aria-hidden`, no `title`. The CALLER owns the meaning — a
 * sole-carrier caller must supply a `title` + `sr-only` pair on its wrapper
 * (root CLAUDE.md's sole-carrier rule), and the size + colour via `className`.
 */
export default function WarningTriangleIcon({ className }) {
  return (
    <svg className={className || 'w-3.5 h-3.5'} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.168 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
    </svg>
  );
}
